import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "w-full flex flex-col lg:flex-row justify-between items-start gap-4 mb-4 mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "w-full flex flex-col lg:flex-row justify-between items-start gap-4 mb-8"
}
const _hoisted_5 = { class: "w-full lg:w-4/5" }
const _hoisted_6 = { class: "w-full lg:w-1/5" }
const _hoisted_7 = { class: "w-full lg:w-1/5" }
const _hoisted_8 = {
  class: "w-full mt-4 overflow-y-auto overflow-x-hidden",
  style: {"grid-area":"table"}
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden md:grid lg:grid-cols-12 md:grid-cols-8 gap-2 w-full items-center text-left py-2 border-b font-semibold text-gray-700 text-xs md:text-sm\"><div class=\"lg:col-span-2 md:col-span-2\">Nome</div><div class=\"lg:col-span-1 md:col-span-1\">CRM</div><div class=\"lg:col-span-1 md:col-span-1\">CRM-UF</div><div class=\"lg:col-span-1 md:col-span-1\">Situação</div><div class=\"lg:col-span-1 md:col-span-1\">Data de Inserção</div><div class=\"lg:col-span-2 md:col-span-1\">Inserido Por</div><div class=\"lg:col-span-1 hidden lg:block\">Promovido em</div><div class=\"lg:col-span-2 hidden lg:block\">Promovido Por</div><div class=\"lg:col-span-1 md:col-span-1\">Ações</div></div>", 1)

import { computed, ref, onMounted } from 'vue'

import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'
import {
  useDoctorStore,
  DOCTOR_FETCH_ALL_LIMIT,
  DOCTORS_LOAD_ERROR
} from '@/pinia-store/useDoctorStore'
import { storeToRefs } from 'pinia'
import { useErrorToast } from '@/composables/useErrorToast'
import { useDoctorsLoadError } from '../useDoctorsLoadError'

import EmptyList from '@/components/EmptyList.vue'
import TableAuthorized from '@/components/designSystem/Table/TableAuthorizedDsPolicies.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

import { mdiPlusCircle } from '@mdi/js'
import { formatDateTimeAtBR } from '@/utils/date'

import DsPolicyAuthorizedSkeleton from '@/components/designSystem/Skeleton/DsPolicyAuthorizedSkeleton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'authorized.tab',
  emits: ['update:users'],
  setup(__props, { emit }) {

const { notifyError } = useErrorToast()
const loading = ref(false)
const loadingAuthorized = ref(false)
const currentPage = ref(1)
const itemsPerPage = ref(5)

const showInsert = ref(false)
const doctorStore = useDoctorStore()
const { doctorsCompany } = storeToRefs(doctorStore)
const selectedStatus = ref<'FULLY_AUTHORIZED' | 'PARTIALLY_AUTHORIZED' | ''>('')

const { notifyDoctorsLoadError } = useDoctorsLoadError()

onMounted(async () => {
  loading.value = true
  try {
    doctorStore.doctorQuery.limit = DOCTOR_FETCH_ALL_LIMIT
    await doctorStore.fetchDoctors()
    notifyDoctorsLoadError()
    // await policyStore.fetchAuthorizedDoctorsByDsPolicy(policyStore.currentPolicy!.id)
  } catch (error) {
    notifyError(error, DOCTORS_LOAD_ERROR)
  } finally {
    loading.value = false
  }
})

const toggleInsert = () => {
  showInsert.value = !showInsert.value
}

const selectedUsers = ref<string[]>([])


const setUsers = (v: string[]) => {
  selectedUsers.value = v
  emit('update:users', v)
}

const searchUsers = async (search: string) => {
  try {
    loadingAuthorized.value = true
    await doctorStore.applyFilters({ search }, false)
    doctorsCompany.value = doctorStore.doctorsCompany
    notifyDoctorsLoadError()
  } catch (error) {
    notifyError(error, DOCTORS_LOAD_ERROR)
  } finally {
    loadingAuthorized.value = false
  }
}

const submitUsers = async () => {
  const policyId = dsPolicyStore.currentPolicy?.id

  // Guards locais (estado da tela, não erro de API) — ficam fora do notifyError.
  if (!policyId) {
    console.error('Policy ID não encontrado.')
    return
  }

  if (!selectedStatus.value) {
    console.error('Situação não selecionada.')
    return
  }

  const doctorIds = selectedUsers.value.map(Number)

  const payload = {
    dsPolicyId: policyId,
    doctorIds,
    authorizationStatus: selectedStatus.value
  }

  loading.value = true
  try {
    await dsPolicyStore.addAuthorizedDoctors(policyId, payload)
  } catch (error) {
    // Mantém a seleção e o formulário aberto para o usuário tentar de novo.
    notifyError(error, 'Não foi possível autorizar os médicos na política de restrição.')
    loading.value = false
    return
  }

  selectedUsers.value = []
  selectedStatus.value = ''
  showInsert.value = false

  try {
    await dsPolicyStore.fetchAuthorizedDoctorsByDsPolicy(policyId)
  } catch (error) {
    notifyError(error, 'Não foi possível atualizar a lista de médicos autorizados.')
  } finally {
    loading.value = false
  }
}

const dsPolicyStore = useDsPolicyStore()
const { authorizedDoctors } = storeToRefs(dsPolicyStore)

const paginatedDoctors = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return authorizedDoctors.value.slice(start, end)
})

const pageCount = computed(() => Math.ceil(authorizedDoctors.value.length / itemsPerPage.value))

const changePage = (page: number) => {
  currentPage.value = page
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(DsPolicyAuthorizedSkeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              onClick: toggleInsert,
              class: "flex items-center gap-2 cursor-pointer font-bold text-primary"
            }, [
              _createVNode(_component_v_icon, {
                class: "share-icon",
                color: "primary",
                icon: _unref(mdiPlusCircle),
                size: "32"
              }, null, 8, ["icon"]),
              _createTextVNode(" Inserir Médicos ")
            ])
          ]),
          (showInsert.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_autocomplete, {
                    "onUpdate:modelValue": setUsers,
                    "onUpdate:search": searchUsers,
                    items: _unref(doctorStore).listDoctorsCompany,
                    loading: loadingAuthorized.value,
                    clearable: "",
                    chips: "",
                    multiple: "",
                    class: "w-full",
                    color: "primary20",
                    variant: "outlined",
                    density: "comfortable"
                  }, null, 8, ["items", "loading"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_select, {
                    modelValue: selectedStatus.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStatus).value = $event)),
                    items: [
              { title: 'Totalmente autorizado', value: 'FULLY_AUTHORIZED' },
              { title: 'Parcialmente autorizado', value: 'PARTIALLY_AUTHORIZED' }
            ],
                    "item-title": "title",
                    "item-value": "value",
                    label: "Situação",
                    variant: "outlined",
                    density: "comfortable",
                    color: "primary"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(FilledButton, {
                    onClick: submitUsers,
                    loading: loadingAuthorized.value,
                    text: `Inserir Médicos`,
                    width: "100%",
                    height: "56px"
                  }, null, 8, ["loading"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (paginatedDoctors.value.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDoctors.value, (doc) => {
                    return (_openBlock(), _createBlock(TableAuthorized, {
                      key: doc.id,
                      data: {
              id: doc.id,
              name: doc.doctor.user.name,
              crm: doc.doctor.mainCrm.number,
              crmUf: doc.doctor.mainCrm.uf,
              status:
                doc.authorizationStatus === 'FULLY_AUTHORIZED'
                  ? 'Totalmente autorizado'
                  : doc.authorizationStatus === 'PARTIALLY_AUTHORIZED'
                    ? 'Parcialmente autorizado'
                    : '—',
              insertedAt: _unref(formatDateTimeAtBR)(doc.createdAt),
              insertedBy: doc.createdBy.name,
              promotedAt:
                doc.authorizationStatus === 'FULLY_AUTHORIZED'
                  ? _unref(formatDateTimeAtBR)(doc.promotedAt)
                  : '',
              promotedBy:
                doc.authorizationStatus === 'FULLY_AUTHORIZED' ? doc.promotedBy?.name || '' : ''
            }
                    }, null, 8, ["data"]))
                  }), 128))
                ], 64))
              : (_openBlock(), _createBlock(EmptyList, {
                  key: 1,
                  title: "Nenhum médico autorizado encontrado"
                }))
          ]),
          _createVNode(_component_v_pagination, {
            modelValue: currentPage.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
              changePage
            ],
            "total-visible": 5,
            length: pageCount.value,
            density: "comfortable",
            color: "primary"
          }, null, 8, ["modelValue", "length"])
        ]))
  ]))
}
}

})